<template>
  <v-app-bar app color="primary" dark>
    <!-- ハンバーガーメニューアイコン -->
    <v-app-bar-nav-icon @click="navClick"></v-app-bar-nav-icon>

    <!-- タイトル -->
    <v-toolbar-title class="pl-0 main-title" @click="titleClick">
      {{ title }}
      <span class="subtitle-1">{{ subTitle }}</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <slot></slot>
  </v-app-bar>
</template>

<script>
export default {
  name: 'MainHeader',
  props: {
    title: String,
    subTitle: String,
  },
  methods: {
    navClick() {
      this.$emit('nav-click');
    },
    titleClick() {
      this.$emit('title-click');
    },
  },
};
</script>

<style scoped>
.main-title {
  cursor: pointer;
  font-family: 'Noto Serif JP', serif;
  font-weight: bold;
}</style
>>
